import { render, staticRenderFns } from "./FreeTextFieldsConfiguration.vue?vue&type=template&id=3e5deee8&scoped=true"
import script from "./FreeTextFieldsConfiguration.vue?vue&type=script&setup=true&lang=ts"
export * from "./FreeTextFieldsConfiguration.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./FreeTextFieldsConfiguration.vue?vue&type=style&index=0&id=3e5deee8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e5deee8",
  null
  
)

export default component.exports